import { Component } from '@angular/core';
import { IdleService } from '../../services/idle.service';
import { KeycloakService } from 'keycloak-angular';

@Component({
    selector: 'dmp-idle-warning-dialog',
    templateUrl: './idle-warning-dialog.component.html',
    styleUrls: ['./idle-warning-dialog.component.scss'],
    standalone: false
})
export class IdleWarningDialogComponent {

  display: boolean = false;

  constructor(private idleService: IdleService, private keycloakService: KeycloakService) {}

  showDialog() {
    this.display = true;
  }

  closeDialog() {
    this.display = false;
  }

  onExtendSession() {
    this.idleService.extendSession();
    this.keycloakService.updateToken(60);
    this.closeDialog();
  }

  onLogout() {
    this.keycloakService.clearToken();
    this.keycloakService.logout();
  }
}